import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { MediaObserver } from '@angular/flex-layout';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { SettingsDialogComponent } from '@app/modules/shared/components/settings-dialog/settings-dialog.component';
import { AssetDetailsFacade } from '@app/modules/asset-details-live-container/facade/asset-details-facade.service';
import { ViewContext } from '@app/store/layout/reducers/layout.reducer';

@Component({
  selector: 'zui-sidenav-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class SideNavHeaderComponent implements OnInit {
  @Input() title: string;
  /* The default view when the side nav is going to show as drawer/overlay */
  /* Above this breakpoint, the sidenav will be displayed on push mode and will be visible  */
  @Input() mobileViewWidthBreakpoint = 62;
  @Input() hideMobileMenuButton = false;
  @Output() menuToggled = new EventEmitter<boolean>();
  // @Output() emitSelectedCompany: EventEmitter<CompanyOption> = new EventEmitter<CompanyOption>();

  /* true when the view is less than a mobile breakpoint */
  isMobileView = false;

  defaultWidthToOverlaySideNav = 62;
  config = new MatDialogConfig();

  constructor(
    public media: MediaObserver,
    private breakpointObserver: BreakpointObserver,
    public dialog: MatDialog,
    public assetDetailsFacade: AssetDetailsFacade
  ) {}

  ngOnInit(): void {
    this.subscribeToBreakpoints();
    this.config.maxWidth = '100vw';
    this.config.maxHeight = '100vh';
    this.config.panelClass = 'settings-dialog';
  }

  subscribeToBreakpoints() {
    // We decided to use a min breakpoint, it is also possible to implement specific sizes e.g.
    // this.breakpointObserver.observe([
    //   Breakpoints.Handset, ...
    // ])

    this.breakpointObserver
      .observe(['(min-width: ' + this.mobileViewWidthBreakpoint + 'rem)'])
      .subscribe((state: BreakpointState) => {
        if (state.matches) {
          this.isMobileView = false;
        } else {
          this.isMobileView = true;
        }
      });
  }

  onMenuButtonClick(event) {
    this.menuToggled.emit(true);
  }

  dialogConfig = mobile => {
    this.config.height = mobile ? '100vh' : 'auto';
    this.config.width = mobile ? '100vw' : '50vw';
    return this.config;
  };

  handleSettingsDialog() {
    const dialogRef = this.dialog.open(SettingsDialogComponent, this.dialogConfig(true));
    dialogRef.afterClosed().subscribe(result => {
      this.assetDetailsFacade.setViewContext(ViewContext.LIST);
    });
  }
}
